<template>
  <div class="page">
    <div class="container block-primary">
      <h1 class="header-title">Privacy Policy</h1>
      <small>Last updated: December 8th, 2017</small>
      <p>BNK48 (“us”, “we”, or “our”) operates website “www.bnk48.com”. This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the application.</p>
      <p>We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.</p>
      <h2>Collection and Use of Information</h2>
      <p>We collect personal information from our users so we could create their accounts, operate the services we provide, improve the services we provide and to be able to contact our users in case we need to. We store the collected information on our servers.</p>
      <h2>Log in with Facebook Connect</h2>
      <p>You have the option to log in into www.bnk48.com using Facebook Connect. This sign-in service will authenticate your identity and give you the option to share some personal information.</p>
      <p>Such sign-in services allow the collection and storage of user information and we may do this, within the boundaries of their terms and policies. Some of the information collected may include, but is not limited to: your name, username, sign-in service ID number, email address, and profile picture</p>
      <h2></h2>
      <p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// Policy.vue?612e498e